/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Sol_Operasional_A2dInputs */

const en_mk_sol_operasional_a2d = /** @type {(inputs: Mk_Sol_Operasional_A2dInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Builds the periodic reports from a format stored as a Skill, period after period.`)
};

const id_mk_sol_operasional_a2d = /** @type {(inputs: Mk_Sol_Operasional_A2dInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Menyusun laporan berkala dari format yang tersimpan sebagai Skill, tanggal demi tanggal.`)
};

/**
* | output |
* | --- |
* | "Builds the periodic reports from a format stored as a Skill, period after period." |
*
* @param {Mk_Sol_Operasional_A2dInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_sol_operasional_a2d = /** @type {((inputs?: Mk_Sol_Operasional_A2dInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Sol_Operasional_A2dInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_sol_operasional_a2d(inputs)
	return en_mk_sol_operasional_a2d(inputs)
});